import { render, staticRenderFns } from "./SwitchProfile.vue?vue&type=template&id=fcba0e2c&scoped=true&"
import script from "./SwitchProfile.vue?vue&type=script&lang=js&"
export * from "./SwitchProfile.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProfile.vue?vue&type=style&index=0&id=fcba0e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba0e2c",
  null
  
)

export default component.exports